/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Lifecycle of a single hiring-manager intake link.

PENDING_SCHEDULE → SCHEDULED → CALLED → (COMPLETED | FAILED)
Terminal off-path: CANCELLED, EXPIRED.

FINALIZING is the generic-QA note-injector's intermediate claim: it
atomically moves CALLED → FINALIZING as its idempotency lock, then
FINALIZING → COMPLETED only after the transcript is durably saved. A hard
crash mid-finalize leaves the row FINALIZING (honestly non-terminal) rather
than a COMPLETED row pointing at a transcript-less note. On a caught pipeline
failure the row falls back to FAILED. (The DIAL_IN autopilot finalizer has a
separate Redis idempotency lock and still claims CALLED → COMPLETED directly
via ``claim_for_finalize``.) Monitoring should treat COMPLETED and FAILED as
terminal and FINALIZING as in-progress.
 */
export type HiringManagerIntakeLinkStatus =
  (typeof HiringManagerIntakeLinkStatus)[keyof typeof HiringManagerIntakeLinkStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HiringManagerIntakeLinkStatus = {
  PENDING_SCHEDULE: 'PENDING_SCHEDULE',
  SCHEDULED: 'SCHEDULED',
  CALLED: 'CALLED',
  FINALIZING: 'FINALIZING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
